import ChatLoading from './ChatLoading'

export default ChatLoading
